'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupRestrictionsView$$anon$49() {
  this.aVa = null;
  this.aVb = false;
}
export { $c_Lpresto_GroupRestrictionsView$$anon$49 as $c_Lpresto_GroupRestrictionsView$$anon$49 };
$p = $c_Lpresto_GroupRestrictionsView$$anon$49.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupRestrictionsView$$anon$49;
/** @constructor */
function $h_Lpresto_GroupRestrictionsView$$anon$49() {
}
export { $h_Lpresto_GroupRestrictionsView$$anon$49 as $h_Lpresto_GroupRestrictionsView$$anon$49 };
$h_Lpresto_GroupRestrictionsView$$anon$49.prototype = $p;
$p.P = (function() {
  if ((!this.aVb)) {
    this.aVa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aVb = true;
  }
  return this.aVa;
});
var $d_Lpresto_GroupRestrictionsView$$anon$49 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupRestrictionsView$$anon$49, "presto.GroupRestrictionsView$$anon$49", ({
  Jr: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_GroupRestrictionsView$$anon$49 as $d_Lpresto_GroupRestrictionsView$$anon$49 };
//# sourceMappingURL=presto.-Group-Restrictions-View$$anon$49.js.map
